// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".target-text{max-width:40vw}.control-group.case-select{align-self:flex-start;min-height:36px}.tripling-renewables{stroke:#000;stroke-width:1px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
